import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Container } from '@hvcgroep/design-system';
import useAuth from '../../hooks/useAuth';
import Page from '../Page';
import Error from '../../pages/Error';
import SkeletonLoader from '../SkeletonLoader';

interface Props extends React.ComponentProps<typeof Route> {
  Component: React.FC<{}>
}

const PublicRoute = ({
  Component,
  ...rest
}: Props) => {
  const auth = useAuth();

  if (auth.state === 'Unknown') {
    return (
      <Page>
        <Container fluid>
          <SkeletonLoader type="overview" />
        </Container>
      </Page>
    );
  }

  if (auth.state === 'Unauthorized') {
    return (
      <Route {...rest}>
        <Page>
          <Component />
        </Page>
      </Route>
    );
  }

  if (auth.state === 'Authorized') {
    return (
      <Redirect to="/" />
    );
  }

  if (auth.state === 'Error') {
    return (
      <Route {...rest}>
        <Page>
          <Error />
        </Page>
      </Route>
    );
  }

  return (
    // @TODO
    <div>
      Loading
    </div>
  );
};

export default PublicRoute;
